import React, { useState } from 'react';
import PageBanner from '@/components/site/PageBanner';
import SEO from '@/components/site/SEO';
import Reveal from '@/components/site/Reveal';
import axios from 'axios';
import { Handshake, TrendingUp, Users, IndianRupee } from 'lucide-react';

const API = process.env.REACT_APP_API_URL || '';

const inputCls =
  'w-full h-11 px-3.5 border border-slate-200 rounded-lg bg-white outline-none transition focus:border-[#1e73be] focus:ring-2 focus:ring-[#1e73be]/20';

const BecomePartner = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', city: '', profession: '' });
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError('');
    try {
      await axios.post(`${API}/api/forms/submit`, { form_type: 'partner', data: form });
      setDone(true);
    } catch (_) {
      setError('We could not save your registration. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main>
      <SEO
        title="Become a Partner | DSA, CA, Financial Advisor Program | Finirio"
        description="Partner with Finirio and earn attractive commissions. Join our DSA and advisor program to help your network access home loans, LAP, business and personal loans."
        path="/become-partner"
        keywords="finirio partner, dsa registration, become loan agent, financial advisor partnership india"
      />
      <PageBanner title="Become a Partner" crumbs={[ 'Become a Partner' ]} />
      <section className="py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 lg:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <Reveal>
            <p className="eyebrow-lux mb-3">Grow with us</p>
            <h2 className="font-heading text-[28px] md:text-[34px] font-bold text-[#0b2545] tracking-tight leading-[1.15] mb-4">Partner with India&apos;s fastest growing loan platform</h2>
            <p className="text-slate-600 leading-relaxed mb-7">
              Earn attractive commissions by helping your network access the best loan and investment options.
              Whether you&apos;re a CA, DSA, financial advisor or entrepreneur — we have a partnership program for you.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {[
                { i: IndianRupee, t: 'High Commission', d: 'Industry leading payout structures' },
                { i: TrendingUp, t: 'Growth Support', d: 'Marketing kit and dedicated RM' },
                { i: Users, t: 'Trusted Brand', d: '20+ banks & thousands of happy customers' },
                { i: Handshake, t: 'Long-term Partnership', d: 'Transparent and reliable relationship' },
              ].map((c, i) => (
                <div key={i} className="card-lux p-5 h-full">
                  <div className="w-10 h-10 rounded-lg grid place-items-center mb-3 border border-[#1e73be]/12" style={{ background: 'linear-gradient(160deg,#eaf3fb,#f5faff)' }}>
                    <c.i className="w-5 h-5" style={{ color: '#1e73be' }} />
                  </div>
                  <h3 className="font-heading font-bold text-[#0b2545] mb-1">{c.t}</h3>
                  <p className="text-sm text-slate-600">{c.d}</p>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={140}>
            <div className="card-lux p-8">
              <h3 className="font-heading text-[22px] font-bold text-[#0b2545] mb-1">Register as a Partner</h3>
              <span className="block h-[2px] w-12 mb-5 rounded-full" style={{ background: 'linear-gradient(90deg,#c9a24b,#e8c887)' }} />
              {done ? (
                <p className="text-slate-700">Thanks! Our partnership team will contact you within 24 hours.</p>
              ) : (
                <form className="space-y-3" onSubmit={submit}>
                  <input required placeholder="Full Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
                  <input required placeholder="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} />
                  <input required placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={inputCls} />
                  <input placeholder="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className={inputCls} />
                  <select value={form.profession} onChange={(e) => setForm({ ...form, profession: e.target.value })} className={inputCls}>
                    <option value="">Select Profession</option>
                    <option>CA / Financial Advisor</option>
                    <option>DSA / Loan Agent</option>
                    <option>Real Estate Broker</option>
                    <option>Insurance Agent</option>
                    <option>Entrepreneur</option>
                    <option>Other</option>
                  </select>
                  {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
                  <button type="submit" disabled={submitting} className="btn-lux w-full justify-center !py-3 disabled:opacity-60">
                    {submitting ? 'Submitting…' : 'Register'}
                  </button>
                </form>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default BecomePartner;
